<div class="search-row scheduled-search">
  <mat-form-field>
    @if (searchInput.value) {
    <button mat-icon-button matSuffix (click)="clearSearch()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    } @if (!searchInput.value) {
    <button mat-icon-button class="search-icon" matSuffix>
      <mat-icon svgIcon="search"></mat-icon>
    </button>
    }

    <input matInput [formControl]="searchInput" (keydown)="onSearchKeyDown($event)" autocomplete="off" />
  </mat-form-field>
</div>

<mat-selection-list class="item-list scheduled-search-list">
  @for (option of filteredOptionList; track option.value) {
  <mat-list-option [selected]="isSelected(option.value)" [value]="option.value" checkboxPosition="before" (click)="onOptionClicked(option)">
    <ng-container *ngTemplateOutlet="templateRef; context: { $implicit: option.value, search: searchInput.value }"></ng-container>
  </mat-list-option>
  }
</mat-selection-list>
